function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u4E0A\\u79FB\\u4E00\\u5C64",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(12.500000, 12.000000) scale(1, -1) translate(-12.500000, -12.000000) translate(4.000000, 3.000000)",
  fill: "#555555",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.65807804,-0.00486619993 C8.13519561,-0.2293271 8.68799074,-0.25177319 9.18024382,-0.0722044699 L9.38267767,0.0147278195 L16.9487431,3.76570555 C17.9039694,4.21509367 18.2958954,5.34441277 17.7581861,6.25589182 C17.6090813,6.50864168 17.3996989,6.72039152 17.1624787,6.87023161 L17.0170656,6.95253922 L11,10.1682928 L11,7.62877716 L11.533,7.628 L11.5286528,7.61805223 L15.71,5.383 L8.499,1.809 L1.29,5.383 L5.4713453,7.61805124 L5.466,7.628 L6,7.62877716 L6,10.1682928 L0.00421419655,6.96359762 C-0.939729635,6.48788236 -1.29593944,5.34565824 -0.729893065,4.4499522 C-0.573470669,4.20243098 -0.358451452,3.9972545 -0.115825736,3.85340258 L0.0328145507,3.77460221 L7.65807804,-0.00486619993 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line",
  points: "9.5 5 9.5 17 7.5 17 7.5 5"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-Copy",
  transform: "translate(8.500000, 15.221089) rotate(-180.000000) translate(-8.500000, -15.221089) ",
  points: "4.34920863 16.2407434 8.5 12.6829222 12.6507914 16.2407434 11.3492086 17.7592566 8.5 15.317 5.65079137 17.7592566"
})));

function SvgUpper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u4E0A\u79FB\u4E00\u5C64") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpper);
export default __webpack_public_path__ + "static/media/upper.a07609a4.svg";
export { ForwardRef as ReactComponent };